export function getWmsItemUgCode(wmsItem, organization) {
    const lineItem = wmsItem?.lineItem
    if (!lineItem) {
        return null
    }

    if (organization?.wmsDisplayProductSkuAsUgCode && lineItem.productSku) {
        return lineItem.productSku
    }

    return lineItem.variationSku ?? null
}
